/* eslint-disable no-undef */

const REACT_APP_BASE_URL = process.env.REACT_APP_BASE_URL
const REACT_APP_RECONCILIATION_API_URL = process.env.REACT_APP_RECONCILIATION_API_URL
const REACT_APP_MERCADOPAGO_REDIRECT_URI = process.env.REACT_APP_MERCADOPAGO_REDIRECT_URI
const USE_NEW_PLAN_LOGIC = process.env.REACT_APP_USE_NEW_PLAN_LOGIC === 'true'
const SHOW_NEW_GLOBAL66_BANK = process.env.REACT_APP_SHOW_NEW_GLOBAL66_BANK !== 'false'
const CREDIT_CARDS_ALLOWED = process.env.REACT_APP_CREDIT_CARDS_ALLOWED === 'true'
const MERCADOPAGO_PAYMENT_PUBLIC_KEY = process.env.REACT_APP_MERCADOPAGO_PAYMENT_PUBLIC_KEY
const MERCADOPAGO_SUBSCRIPTION_PUBLIC_KEY = process.env.REACT_APP_MERCADOPAGO_SUBSCRIPTION_PUBLIC_KEY
const MERCADOPAGO_PREFERENCE_ID = process.env.REACT_APP_MERCADOPAGO_PREFERENCE_ID
export const IS_TESTING_PAYMENTS = process.env.REACT_APP_TESTING_PAYMENTS === 'true'
export const ADMIN_PANEL_URL = process.env.REACT_APP_ADMIN_URL
export const IS_DEVELOPMENT_ENVIRONMENT =
  process.env.NODE_ENV === 'development' ||
  process.env.REACT_APP_ENVIRONMENT === 'development'

const monthsArr = [
  'Enero',
  'Febrero',
  'Marzo',
  'Abril',
  'Mayo',
  'Junio',
  'Julio',
  'Agosto',
  'Septiembre',
  'Octubre',
  'Noviembre',
  'Diciembre'
],
  monthsOptions = Object.freeze(
    monthsArr.map((month, i) => {
      return { value: i + 1, label: month }
    }),
    [{ value: 0, label: 'Todos los meses' }]
  ).flat(),
  currentMonth = new Date().getMonth() + 1

const currentYear = new Date().getFullYear()
const previousYear = currentYear - 1

let currentOrganizationCreatedAt = null

const getYearFromDate = dateValue => {
  if (!dateValue) return null
  const parsedDate = new Date(dateValue)
  const parsedYear = parsedDate.getFullYear()
  return Number.isFinite(parsedYear) ? parsedYear : null
}

const resolveYearsRange = organizationCreatedAt => {
  const organizationYear = getYearFromDate(organizationCreatedAt)

  if (!organizationYear) {
    return [previousYear, currentYear]
  }

  if (organizationYear >= currentYear) {
    return [currentYear]
  }

  return [organizationYear, currentYear]
}

export const setYearsOptionsOrganizationCreatedAt = organizationCreatedAt => {
  currentOrganizationCreatedAt = organizationCreatedAt || null
}

const buildYearsOptions = (organizationCreatedAt = currentOrganizationCreatedAt) => {
  const years = resolveYearsRange(organizationCreatedAt)
  return years.map((year) => ({ value: year, label: `${year}` }))
}

const getYearsOptions = (organizationCreatedAt = currentOrganizationCreatedAt) =>
  buildYearsOptions(organizationCreatedAt)

const getFirstLastRows = firstLastData => {
  if (Array.isArray(firstLastData)) return firstLastData
  if (Array.isArray(firstLastData?.data)) return firstLastData.data
  if (Array.isArray(firstLastData?.libros)) return firstLastData.libros
  return []
}

const getYearFromCodeComprobante = codeComprobante => {
  const firstSegment = String(codeComprobante ?? '').trim().split('-')[0]
  if (!/^\d{4}$/.test(firstSegment)) return null

  const year = Number(firstSegment)
  return Number.isFinite(year) ? year : null
}

const getYearsOptionsFromFirstLast = (firstLastData, organizationCreatedAt) => {
  const years = getFirstLastRows(firstLastData)
    .map(item => getYearFromCodeComprobante(item?.codeComprobante))
    .filter(year => Number.isFinite(year))

  if (!years.length) {
    return buildYearsOptions(organizationCreatedAt)
  }

  const firstYear = Math.min(...years, currentYear)
  const lastYear = Math.max(...years, currentYear)

  return Array.from({ length: lastYear - firstYear + 1 }, (_, index) => {
    const year = firstYear + index
    return { value: year, label: `${year}` }
  })
}

const yearsOptions = new Proxy([], {
  get(_target, prop) {
    const options = buildYearsOptions()
    if (prop === Symbol.iterator) {
      return options[Symbol.iterator].bind(options)
    }
    if (prop === 'length') {
      return options.length
    }
    const value = options[prop]
    if (typeof value === 'function') {
      return value.bind(options)
    }
    return value
  },
  ownKeys() {
    return Reflect.ownKeys(buildYearsOptions())
  },
  getOwnPropertyDescriptor(_target, prop) {
    return Object.getOwnPropertyDescriptor(buildYearsOptions(), prop)
  }
})

const getCurrentDate = () => {
  const today = new Date()
  const month = String(today.getMonth() + 1).padStart(2, '0')
  const year = today.getFullYear()
  const date = String(today.getDate()).padStart(2, '0')
  return `${date}-${month}-${year}`
}

const getLatestMovementMonth = (movements, year) => {
  if (!Array.isArray(movements)) return 0

  return movements.reduce((latestMonth, movement) => {
    const rawDate = movement?.fecha ?? movement?.fechaPago ?? movement?.createdAt
    if (!rawDate) return latestMonth

    const isoMatch = String(rawDate).match(/^(\d{4})-(\d{1,2})/)
    if (isoMatch) {
      const movementYear = Number(isoMatch[1])
      const movementMonth = Number(isoMatch[2])
      return movementYear === Number(year) && movementMonth >= 1 && movementMonth <= 12
        ? Math.max(latestMonth, movementMonth)
        : latestMonth
    }

    const date = new Date(rawDate)
    if (Number.isNaN(date.getTime()) || date.getUTCFullYear() !== Number(year)) {
      return latestMonth
    }

    return Math.max(latestMonth, date.getUTCMonth() + 1)
  }, 0)
}

const DOC_MAP = {
  33: 'FEL',
  34: 'FNA',
  39: 'BEL',
  43: 'LFE',
  45: 'FCO',
  48: 'CPE',
  61: 'NCE',
  110: 'FEX',
  914: 'DIN',
  100: 'BHE'
}

export const MERCADOPAGO = 'mercadopago'
export const GETNET = 'getnet'
export const TRANSBANK = 'transbank'
export const VALIDATION_AMOUNT = 5000

export {
  REACT_APP_BASE_URL,
  REACT_APP_RECONCILIATION_API_URL,
  REACT_APP_MERCADOPAGO_REDIRECT_URI,
  USE_NEW_PLAN_LOGIC,
  SHOW_NEW_GLOBAL66_BANK,
  CREDIT_CARDS_ALLOWED,
  MERCADOPAGO_PAYMENT_PUBLIC_KEY,
  MERCADOPAGO_SUBSCRIPTION_PUBLIC_KEY,
  MERCADOPAGO_PREFERENCE_ID,
  currentYear,
  previousYear,
  currentMonth,
  monthsArr,
  monthsOptions,
  yearsOptions,
  getYearsOptions,
  getYearsOptionsFromFirstLast,
  getLatestMovementMonth,
  DOC_MAP,
  getCurrentDate
}
